// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PageContentPage{background-repeat:repeat-y;margin-bottom:-1rem}@media(min-width:768px){.PageContentPage{margin-bottom:-2rem;margin-top:-.5rem}}.PageContentPage .TopCategory{border:1px solid #dee2e6}.PageContentPage__breadcrumbsWrapper{position:absolute;top:0;width:100%}.PageContentPage__contentWrapper{padding-top:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
